import type { ReactNode } from 'react';
import { Box } from '@mantine/core';
import { layoutTokens } from '../tokens/layoutTokens';
import classes from './PageContainer.module.css';

export function PageContainer({ children }: { children: ReactNode }) {
  return (
    <Box
      className={classes.root}
      maw={layoutTokens.pageMaxWidth}
      mx="auto"
      w="100%"
    >
      {children}
    </Box>
  );
}
